import { render, staticRenderFns } from "./VueChartist.vue?vue&type=template&id=120d9da8"
import script from "./VueChartist.vue?vue&type=script&lang=js"
export * from "./VueChartist.vue?vue&type=script&lang=js"
import style0 from "./VueChartist.vue?vue&type=style&index=0&id=120d9da8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports